import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder } from '@angular/forms';
import { SelectEvent } from '@progress/kendo-angular-upload';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';
import { ExtendedProfile } from 'src/app/common/ExtendedProfile';
import { CustomSellerInfo } from 'src/app/common/CustomSellerInfo';
import { AppProfileService } from 'src/app/services/profile.service';
import { CustomSellerInfoService } from 'src/app/services/custom-seller-info.service';
import { readAsDataUrl } from 'src/app/common/browser-files';

/** The seller info view form; its type is inferred from here (#199). */
function buildSellerInfoForm(fb: FormBuilder, info: CustomSellerInfo) {
  return fb.group({
    editor: [info?.brandInfoText],
    // The Kendo file picker's value: the selected files, none to start with.
    files: [[] as File[]],
  });
}
type SellerInfoForm = ReturnType<typeof buildSellerInfoForm>;

@Component({
    imports: [],
    selector: 'app-custom-seller-info',
    templateUrl: './custom-seller-info.component.html'
})
export class CustomSellerInfoComponent implements OnInit {
  private fb = inject(FormBuilder);
  private profileService = inject(AppProfileService);
  private customSellerInfoService = inject(CustomSellerInfoService);
  private toastr = inject(ToastrService);

  // Stays a decorator input: setting it reloads the seller info. A signal input would need an
  // effect() for that, which is a behaviour change rather than part of the #199 sweep.
  @Input() set CustomerId(customerId: string) {
    this.customerId = customerId;
    this.refresh();
  };

  private destroyRef = inject(DestroyRef);

  public myForm: SellerInfoForm;
  public customSellerInfo: CustomSellerInfo;
  private profile: ExtendedProfile;
  public files: Array<File> = [];
  public submitted = false;
  public imageFile: any;
  private customerId: string = null;

  ngOnInit(): void {
    this.refresh();
  }

  public selectImageEventHandler(e: SelectEvent) {
    readAsDataUrl(e.files[0].rawFile, (url) => (this.imageFile = url));
  }

  private refresh() {
    this.profileService.currentProfile$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((p) => {
      this.profile = p;
      if(this.customerId){
        this.Load();
      }
    });

    this.refreshForm();
  }

  private Load() {
    this.customSellerInfoService
      .getForCustomer(this.customerId)
      .pipe(take(1))
      .subscribe({
        next: (d) => {
          this.customSellerInfo = d;
          this.refreshForm();
          this.loadBrandImage();
        },
        error: (e: HttpErrorResponse) => {
          if (e.status === 404) {
            this.customSellerInfo = new CustomSellerInfo();
            this.customSellerInfo.customerId = this.profile.customer.id;
            this.refreshForm();
          } else {
            this.toastr.error($localize`Es konnten keine Anbieterinformationen geladen werden.`);
          }
        },
      });
  }

  private loadBrandImage() {
    this.customSellerInfoService
      .getBrandImage(this.customerId)
      .pipe(take(1))
      .subscribe((image) => readAsDataUrl(image, (url) => (this.imageFile = url)));
  }

  private refreshForm() {
    this.myForm = buildSellerInfoForm(this.fb, this.customSellerInfo);
  }
}
